import { render, staticRenderFns } from "./Tab9.vue?vue&type=template&id=33946058&scoped=true"
import script from "./Tab9.vue?vue&type=script&lang=js"
export * from "./Tab9.vue?vue&type=script&lang=js"
import style0 from "./Tab9.vue?vue&type=style&index=0&id=33946058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33946058",
  null
  
)

export default component.exports